import EMVERSITY from "@/assets/industry-co-led/partners/EMVERSITY.png";
import Icon1 from "@/assets/industry-co-led/logo/madel.png";
import Icon2 from "@/assets/industry-co-led/logo/network.png";

import Student1 from "@/assets/students/student1.png";
import Student2 from "@/assets/students/student2.png";
import Student3 from "@/assets/students/student3.png";
import Student4 from "@/assets/students/student4.png";

const OJLImg1 = "https://cdn.msu.edu.in/industry_learning_HA_2_1a43415474.jpg";
const OJLImg2 = "https://cdn.msu.edu.in/industry_learning_HA_6_ac545050a1.jpg";
const OJLImg3 = "https://cdn.msu.edu.in/art_1_21aa340e2f.webp";
const OJLImg4 = "https://cdn.msu.edu.in/Classroom_b8d97e6eca.jpg";
const OJLImg5 = "https://cdn.msu.edu.in/BHA_3_1_02d5a7abdc.webp";2
const OJLImg6 = "https://cdn.msu.edu.in/msu_advantages_8519d5e66d_7df07e3dd7.webp";

const Img1 = "https://cdn.msu.edu.in/art_1_21aa340e2f.webp";
const Img2 = "https://cdn.msu.edu.in/industry_learning_HA_2_1a43415474.jpg";
const Img3 = "https://cdn.msu.edu.in/Classroom_b8d97e6eca.jpg";
const Img4 = "https://cdn.msu.edu.in/industry_learning_HA_6_ac545050a1.jpg";
const Img5 = "https://img.youtube.com/vi/UHgiEfYqLNs/hqdefault.jpg";

export const bhaData = {

    heroSection: {
        breadcrumb: [
            { name: "Home", url: "/" },
            { name: "Industry Co-led UG Programmes", url: "/industry-co-led-ug-programmes" },
            { name: "Bachelor of Hospital Administration", url: "" }
        ],
        // Image from MSU Offering section
        bannerImg: "https://cdn.msu.edu.in/campus/hospital-administration.webp",
        title: "Bachelor of Hospital Administration",
        poweredBy: {
            text: "Industry Skilling Partner",
            logo: EMVERSITY
        },
        duration: "3 Year Undergraduate Degree Programme",
        description:
            "Learn about Hospital Operations, Healthcare Finance, Medical Records, NABH/JCI accreditation, Healthcare IT and more in the healthcare sector.",

        stats: [
            {
                value: "Up to 70%",
                label: "Practical Curriculum"
            },
            {
                value: "Paid",
                label: "On-the-job learning"
            },
            {
                value: "100%",
                label: "Placement Assistance"
            }
        ],

        buttons: {
            download: "Download Brochure",
            enroll: "Enroll Now"
        },

        video: {
            thumbnail: "https://img.youtube.com/vi/UHgiEfYqLNs/hqdefault.jpg",
            buttonText: "Watch Programme Video",
            url: "https://www.youtube.com/embed/UHgiEfYqLNs"
        }
    },

    aboutSection: {
        tag: "ABOUT THE PROGRAMME",
        title: "A Degree Designed for Modern Healthcare Leadership",
        description: [
            "The Bachelor of Hospital Administration transforms students into high impact leaders capable of navigating the complex world of modern healthcare. This program moves beyond the bedside to focus on the machinery of medicine, integrating hospital finance, legal ethics and quality accreditation standards into a powerhouse management curriculum.",
            "By evolving from basic medical terminology to sophisticated disaster management and hospital design, students develop the sharp strategic mindset and operational expertise required to run world class facilities or launch innovative ventures in the health tech and insurance sectors."
        ],
        stats: [
            { value: "Up to 70%", label: "Hands-on training" },
            { value: "Paid", label: "On-the-job learning" },
            { value: "100%", label: "Placement assistance" }
        ],
        approvals: [
            "UGC Approved",
            "NEP 2020 Aligned",
            "Scholarships Available"
        ],
        journeyTitle: "Your 3-Year Journey",
        journey: [
            {
                "phase": "YEAR 1",
                "title": "Foundation Sciences & Management",
                "description": "Medical terminology, IT systems, and healthcare fundamentals"
            },
            {
                "phase": "YEAR 2",
                "title": "Core Hospital Operations",
                "description": "Medical records, waste management, and emergency care modules"
            },
            {
                "phase": "YEAR 3",
                "title": "Advanced Management & Planning",
                "description": "Quality systems, medical ethics, and disaster management"
            },
            {
                "phase": "GRADUATE",
                "title": "Bachelor of Hospital Administration",
                "description": "Industry-ready professional"
            }
        ]
    },

    offeringSection: {
        tag: "OUR OFFERING",
        title: {
            first: "Comprehensive",
            highlight: "Allied Healthcare Education"
        },
        description:
            "We offer a UGC-approved, full-time undergraduate degree, Bachelor of Hospital Administration at Medhavi Skills University, Sikkim. It is an industry-aligned allied healthcare degree designed to build strong skills and prepare students for diverse roles.",
        learningBox: {
            title: "Key Areas of Learning",
            points: [
                "Healthcare Business Environment",
                "Principles of Hospital Administration",
                "Hospital Information System",
                "Economics for Healthcare",
                "Epidemiology and Public Health",
                "Hospital Public Relations & Communication"
            ]
        },
        image: "https://cdn.msu.edu.in/BHA_3_1_02d5a7abdc.webp"
    },

    whyEMT: {
        tag: "WHY HOSPITAL ADMINISTRATION. WHY NOW.",
        title: "The Rapidly Growing Sector of Allied and Healthcare",
        description:
            "Our curriculum responds to the massive scale of India's healthcare transformation, preparing you for a sector that is becoming the backbone of the national economy.",
        stats: [
            {
                value: "$372 Billion",
                text: "Projected valuation of the Indian Healthcare Sector. As the industry grows at a CAGR of ~22%, there is a critical need for trained professionals to manage the massive influx of capital and infrastructure.",
            },
            {
                value: "100,000+",
                text: "Shortfall of Hospital Administrators across the country. With the rise of corporate hospital chains and the expansion of the Ayushman Bharat scheme, the demand for management talent far outstrips the current supply.",
            },
            {
                value: "~70,000",
                text: "Public and Private Hospitals in India are currently undergoing digital transformation. Professionals who can navigate NABH accreditation and Digital Health Missions are now the most sought-after assets in the industry.",
            },
        ],
    },

    msuAdvantages: {
        tag: "MSU ADVANTAGES",
        title: "Programme by Emversity, Delivered at MSU Campus",
        description:
            "Where academic excellence meets the operational demands of the modern allied and healthcare industry.",
        cards: [
            {
                number: "01",
                text: "Only university in Sikkim aligned with paid On-the-Job Learning embedded curriculum for practical learning.",
            },
            {
                number: "02",
                text: "Only university in Sikkim to ensure 100% of our student applicants receive government scholarships.",
            },
            {
                number: "03",
                text: "Well-equipped simulation labs, advanced training setups and hands-on field training.",
            },
        ],
        pointerTitle: "Highlights from The Programme:",
        highlights: [
            "Programme aligned with NEP2020, focused in Learning Outcome Based Education",
            "Up to 70% practical based curriculum",
            "Paid On-the-job Learning",
            "Industry-aligned curriculum & hands-on learning",
            "Learn from seasoned professionals",
            "Immersive industry exposure through industry visits, guest lectures and networking opportunities",
            "Chance to 'learn and earn' through immersive on-the-job learning, industry projects and internships with leading companies",
            "Engage with industry experts to get invaluable insights and real-world perspectives"
        ],
        // Advantage/Campus Image
        image: "https://cdn.msu.edu.in/msu_advantages_8519d5e66d_7df07e3dd7.webp",
    },

    CTA: {
        title: "Start Your Journey in Healthcare Management with Emversity's",
        highlights: "Bachelor of Hospital Administration",
        url: "#",
        btnName: "Apply Now"
    },

    onJobtrainningData: {
        tag: "ON-THE-JOB LEARNING",
        title: "Practical Industry Exposure",
        description: "Our On-the-job Learning (OJL) enables students to gain real industry experience and earn a stipend while you gain your degree.",
        images: [
            { "id": 1, "src": OJLImg1, "alt": "Co-learning spaces" },
            { "id": 2, "src": OJLImg2, "alt": "Admission desk management" },
            { "id": 3, "src": OJLImg3, "alt": "Classroom sessions" },
            { "id": 4, "src": OJLImg4, "alt": "Computer lab training" },
            { "id": 5, "src": OJLImg5, "alt": "Hospital administration learning" },
            { "id": 6, "src": OJLImg6, "alt": "MSU campus facilities" }
        ]
    },

    addtionSkill: {
        "courseSections": {
            "AdditionalSkills": {
                "tag": "BONUS CREDENTIALS",
                "title": "Additional Skill Development",
                "description": "Students will have the opportunity to build additional skills that set them apart in the competitive healthcare market. These credentials, earned alongside your degree, validate your technical expertise, boost your professional credibility, and ensure you are ready for employment with leading national and international healthcare providers.",
                "image": {
                    "url": "https://cdn.msu.edu.in/small_ADP_7797_1_398464585e.jpg",
                    "alternativeText": "Skill Certification"
                },
                "items": [
                    { "id": 1, "text": "Cambridge English for Healthcare Professionals as per CEFR Standards", "icon": Icon1 },
                    { "id": 2, "text": "NABH & Quality Standards Mastery", "icon": Icon2 },
                    { "id": 3, "text": "Nationally & Globally Recognised", "icon": Icon1 }
                ],
                "button": { "text": "Apply Now", "link": "/apply" }
            }
        }
    },

    DoExperienceLearndata: {
        tag: "INFRASTRUCTURE",
        title: "Do-Experience-Learn",
        description: "Discover the advantage of MSU's cutting-edge infrastructure, featuring modern laboratories, classrooms and industry-relevant facilities.",
        images: [
            { id: 1, src: Img1, size: "large", alt: "Classrooms" },
            { id: 2, src: Img2, size: "large", alt: "Co-Learning Spaces" },
            { id: 3, src: Img3, size: "small", alt: "Computer Labs" },
            { id: 4, src: Img4, size: "small", alt: "Admission Desk Management" },
            { id: 5, src: Img5, size: "small", alt: "Virtual Campus Tour" },
        ],
    },

    studentStoriesData: {
        title: "Medhavian Speak",
        subText: "Real journeys of action and achievement.",
        students: [
            { name: "Radhika Chettri", image: Student2, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Allied-Healthcare-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Allied-Healthcare-short.mp4" },
            { name: "Pratik Chettri", image: Student3, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Computer-Science-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Computer-Science+-short.mp4" },
            { name: "Suhana Sharma", image: Student4, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Pharmacy-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Pharmacy-short.mp4" },
            { name: "Hissey Bhutia", image: Student1, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Nursing-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Nursing-short.mp4" },
        ],
    },

    eligibility: {
        tag: "ELIGIBILITY",
        title: "Who Can Apply?",
        description: "10+2 (Any Stream) with 50% Aggregate",
        button: { text: "Apply Now", url: "" },
        items: [
            {
                title: "12th Pass - Any Stream",
                text: "Candidates from any stream with 50% aggregate marks are eligible to apply for the Bachelor of Hospital Administration programme.",
            },
        ],
    },

    careerProspects: {
        "tag": "CAREER PROSPECTS",
        "heading": "Career Prospects",
        "description": "The Bachelor of Hospital Administration opens doors to a diverse range of leadership roles across the rapidly expanding Indian healthcare ecosystem.",
        "roles": [
            "Hospital Manager / Operations Executive",
            "Quality Manager / NABH & JCI Accreditation Lead",
            "Patient Services Coordinator / Front Office Manager",
            "Medical Records Manager / Health Information Executive",
            "Healthcare Consultant / Strategy Associate",
            "Health Insurance Executive / TPA Coordinator",
            "Supply Chain & Inventory Manager / Purchase Officer",
            "Public Health Administrator / Program Manager"
        ]
    },

    curriculumStructure: {
        "label": "WHAT YOU WILL LEARN",
        "heading": "Curriculum Structure",
        "description": "At Medhavi Skills University, the curriculum balances academic rigour with immersive industry modules, ensuring students gain real-world administrative experience throughout their degree.",
        "semesters": [
            {
                "name": "Semester 1",
                "title": "Building Foundations in Healthcare Management and Administration",
                "description": "The first semester introduces students to the fundamental concepts of healthcare administration, organizational operations, and professional communication. Learners gain an understanding of healthcare business environments, hospital systems, medical terminology, and record management practices that support effective healthcare delivery. The curriculum also emphasizes digital proficiency, communication skills, and personal effectiveness, enabling students to develop the professional, administrative, and interpersonal competencies required for successful careers in healthcare management.",
                "subjects": [
                    { "name": "Fundamentals of Digital Applications", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Healthcare Business Environment", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Medical Terminology and Record Keeping", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Hospital and Health System", "bgColor": "bg-[#E8D5FF]", "textColor": "text-[#6B00CC]" },
                    { "name": "English and Communication – Essential Skills", "bgColor": "bg-[#FFD5D5]", "textColor": "text-[#CC0000]" },
                    { "name": "Personal Effectiveness", "bgColor": "bg-[#D5F0FF]", "textColor": "text-[#006699]" }
                ]
            },
            {
                "name": "Semester 2",
                "title": "Strengthening Operational and Administrative Competencies in Healthcare",
                "description": "The second semester builds upon foundational management concepts by introducing students to hospital administration, healthcare operations, and financial management practices. Learners develop an understanding of administrative processes, accounting principles, and operational frameworks that support efficient healthcare delivery. The curriculum also emphasizes advanced communication, interpersonal effectiveness, and healthcare management fundamentals, enabling students to strengthen their professional capabilities and prepare for administrative and managerial responsibilities within healthcare organizations.",
                "subjects": [
                    { "name": "English and Communication – Advanced Skills", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Principles of Hospital Administration", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Basics of Professional Accounting – Concept", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Basics of Professional Accounting – Applied", "bgColor": "bg-[#E8D5FF]", "textColor": "text-[#6B00CC]" },
                    { "name": "Hospital Operation Management", "bgColor": "bg-[#FFD5D5]", "textColor": "text-[#CC0000]" },
                    { "name": "Science and World", "bgColor": "bg-[#D5F0FF]", "textColor": "text-[#006699]" },
                    { "name": "Foundation of Healthcare Management", "bgColor": "bg-[#FFF3CC]", "textColor": "text-[#996600]" },
                    { "name": "Interpersonal Effectiveness", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" }
                ]
            },
            {
                "name": "Semester 3",
                "title": "Integrating Technology, Compliance and Strategic Healthcare Management",
                "description": "The third semester focuses on the administrative, technological, and regulatory aspects of modern healthcare systems. Students gain insights into healthcare laws, hospital information systems, human resource management, and infection control practices that are critical to effective healthcare operations. The curriculum also explores emerging applications of artificial intelligence in healthcare, business communication, and medical tourism, enabling learners to understand the evolving landscape of healthcare management while developing the skills required to support efficient, compliant, and patient-centric healthcare organizations.",
                "subjects": [
                    { "name": "Legal Aspects of Healthcare", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Hospital Information System", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Human Resource Management", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Business Communication", "bgColor": "bg-[#E8D5FF]", "textColor": "text-[#6B00CC]" },
                    { "name": "AI in Healthcare Management", "bgColor": "bg-[#FFD5D5]", "textColor": "text-[#CC0000]" },
                    { "name": "Hospital Infection Control Management", "bgColor": "bg-[#D5F0FF]", "textColor": "text-[#006699]" },
                    { "name": "Medical Tourism", "bgColor": "bg-[#FFF3CC]", "textColor": "text-[#996600]" }
                ]
            },
            {
                "name": "Semester 4",
                "title": "Optimizing Healthcare Resources and Organizational Efficiency",
                "description": "The fourth semester focuses on the efficient management of healthcare resources, operations, and organizational processes. Students gain an understanding of inventory and supply chain management, healthcare economics, and the psychological aspects that influence workplace dynamics and patient interactions. Through project-based learning and industry immersion, learners are exposed to real-world healthcare environments, enabling them to connect classroom concepts with operational practices while developing analytical, managerial, and problem-solving skills essential for healthcare administration.",
                "subjects": [
                    { "name": "Hospital Inventory & Supply Chain Management", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Economics for Healthcare", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Project", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Psychology", "bgColor": "bg-[#E8D5FF]", "textColor": "text-[#6B00CC]" },
                    { "name": "Industry Immersion (BHA) – 1", "bgColor": "bg-[#FFD5D5]", "textColor": "text-[#CC0000]" }
                ]
            },
            {
                "name": "Semester 5",
                "title": "Advancing Strategic Healthcare Operations and Quality Management",
                "description": "The fifth semester equips students with the knowledge and skills required to manage complex healthcare operations while ensuring quality, safety, and sustainability. Learners explore healthcare quality standards, public health principles, disaster preparedness, and advanced hospital operations. The curriculum also focuses on hospital planning, health insurance systems, and entrepreneurial opportunities within the healthcare sector, enabling students to develop a strategic understanding of healthcare management and prepare for leadership roles in evolving healthcare environments.",
                "subjects": [
                    { "name": "Quality Management in Healthcare Services", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Epidemiology and Public Health", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Hospital Hazards and Disaster Management", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Advanced Hospital Operation Management", "bgColor": "bg-[#E8D5FF]", "textColor": "text-[#6B00CC]" },
                    { "name": "Hospital Planning and Management", "bgColor": "bg-[#FFD5D5]", "textColor": "text-[#CC0000]" },
                    { "name": "Health Insurance", "bgColor": "bg-[#D5F0FF]", "textColor": "text-[#006699]" },
                    { "name": "Entrepreneurship in Healthcare", "bgColor": "bg-[#FFF3CC]", "textColor": "text-[#996600]" }
                ]
            },
            {
                "name": "Semester 6",
                "title": "Leveraging Data, Innovation and Stakeholder Engagement in Healthcare",
                "description": "The sixth semester focuses on the analytical, technological, and relationship-driven aspects of healthcare management. Students develop an understanding of research methodologies, business fundamentals, health informatics, and customer relationship management, enabling them to make informed administrative decisions in dynamic healthcare environments. The curriculum also emphasizes effective communication, public relations, and industry exposure, helping learners strengthen their strategic thinking, professional competencies, and ability to contribute to the growth and transformation of healthcare organizations.",
                "subjects": [
                    { "name": "Research Methodology and Biostatistics", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Fundamentals of Business", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Hospital Public Relations & Communication", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Introduction to Health Informatics", "bgColor": "bg-[#E8D5FF]", "textColor": "text-[#6B00CC]" },
                    { "name": "Customer Relationship Management", "bgColor": "bg-[#FFD5D5]", "textColor": "text-[#CC0000]" },
                    { "name": "Industry Immersion (BHA) – II", "bgColor": "bg-[#D5F0FF]", "textColor": "text-[#006699]" }
                ]
            },
            {
                "name": "Semester 7",
                "title": "Applying Healthcare Management Principles in Real-World Settings",
                "description": "The seventh semester is dedicated to immersive industry exposure, enabling students to experience the operational, administrative, and strategic functions of healthcare organizations firsthand. Through structured industry immersion, learners observe healthcare workflows, management practices, patient service systems, and organizational processes in real-world environments. This experiential learning opportunity helps bridge the gap between academic knowledge and professional application, while strengthening workplace readiness, problem-solving abilities, and managerial competencies essential for a successful career in healthcare administration.",
                "subjects": [
                    { "name": "Industry Immersion (BHA) – III", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" }
                ]
            },
            {
                "name": "Semester 8",
                "title": "Demonstrating Professional Competence Through Industry Practice and Research",
                "description": "The final semester enables students to consolidate their learning through advanced industry exposure and independent research. Through industry immersion, learners gain deeper insights into healthcare operations, administration, and organizational management within real-world healthcare settings. The dissertation component encourages students to apply research methodologies to investigate relevant healthcare management challenges, fostering analytical thinking, problem-solving abilities, and evidence-based decision-making. Together, these experiences prepare graduates to confidently transition into professional roles within the healthcare industry.",
                "subjects": [
                    { "name": "Industry Immersion (BHA) – IV", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Dissertation", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" }
                ]
            },
            {
                name: "Value Addition",
                title: "Value-Added Learning Opportunities",
                description: "Students gain access to skill certifications, semester-wise workshops, and industry visits that enhance practical learning and professional development. Additionally, aspiring entrepreneurs can explore venture creation opportunities with mentorship, incubation support, and access to funding through the Medhavi NextGen Innovation and Incubation Center and government-backed initiatives.",
                "keySubjectsLabel": "Key Features",
                subjects: [
                    { "name": "Skill certifications", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "One workshop per semester", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "One industry visit per semester", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Opportunity for venture creation through university and government funding (Medhavi NextGen Innovation and Incubation Center)", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" }
                ],
                "learningOutcomes": [
                    "Gain real-world experience through the Red.Health Network internship",
                    "Execute industry-based projects in healthcare settings",
                    "Complete a capstone project and dissertation",
                    "Transition confidently into healthcare management roles",
                    "Prepare professionally through CV launch and career readiness activities"
                ]
            }
        ]
    },

    faq: {
        id: 102,
        title: "Bachelor of Hospital Administration",
        FAQ: [
            {
                "id": 1,
                "Question": "What is the university's role and what is Emversity's role?",
                "Answer": "MSU manages all academic matters — admissions, examinations, marksheets, transcripts, and degree conferral. All fees are payable directly to the university. Emversity is the industry-skilling partner and delivers AR/VR simulation training, industry-co-designed skill modules, clinical internship facilitation, placement assistance, and the Cambridge English program. Emversity does not collect fees, conduct exams, or award degrees."
            },
            {
                "id": 2,
                "Question": "Is placement or internship stipend guaranteed?",
                "Answer": "Emversity provides placement assistance through its network of 500+ healthcare employer partners and facilitates structured clinical internships. However, placement is not guaranteed and stipend amounts vary by employer. Final hiring and stipend decisions rest with the host institution."
            },
            {
                "id": 3,
                "Question": "Is this program recognised, and is it full-time?",
                "Answer": "Yes, this is a full-time, on-campus program. MSU is established under the Medhavi Skills University, Sikkim Act, 2021 and is recognised by the UGC under Section 2(f)."
            },
            {
                "id": 4,
                "Question": "How do I apply?",
                "Answer": "Applications are submitted through MSU's official admissions portal. Candidates may be required to appear for the Medhavi Scholarship & Aptitude Test (MSAT). For eligibility verification, fee details, and application deadlines, please contact the MSU admissions office directly."
            },
            {
                "id": 5,
                "Question": "What is the Head Start Programme?",
                "Answer": "The Head Start Programme is a zero-cost, online bridge course offered before classes begin. It covers foundational concepts and essential skills for your chosen field. Participation is voluntary, non-credit-bearing, and does not affect admission status or academic standing. Students who successfully complete it receive a complimentary laptop and may be eligible for additional scholarships."
            }
        ]
    },

    coursePrice: { price: "₹6,00,000" }
};